import { Link, TableBody, TableCell, TableRow } from '@material-ui/core'

import React, { FC } from 'react'

import { BLOG_STATUS } from '../../constants/enums/blog.enum.constant'
import { BlogListInterface } from '../../interfaces/blog'
import { convertDateTimeToString, truncateString } from '../../utils/common'

const BlogTableBody: FC<any> = ({ blogs }: { blogs: BlogListInterface[] }) => (
  <TableBody>
    {blogs.map((blog) => (
      <TableRow key={blog.blogId} hover={true}>
        <TableCell align="center">
          <Link href={`/blog/${blog.blogId}/edit`}>{blog.blogId}</Link>
        </TableCell>
        <TableCell align="center">{truncateString(blog.title, 50)}</TableCell>
        <TableCell align="center">{BLOG_STATUS[blog.status]}</TableCell>
        <TableCell align="center">
          {convertDateTimeToString(blog.updatedTime)}
        </TableCell>
        <TableCell align="center">{blog.updatedByEmail}</TableCell>
      </TableRow>
    ))}
  </TableBody>
)

export default BlogTableBody
